// extracted by mini-css-extract-plugin
export default {"card":"L5-z"};